import { atomWithReset, RESET } from 'jotai/utils'

import { getStore } from '@/store'

export const addressStreetAtom = atomWithReset<string | undefined>('')
export const addressCityAtom = atomWithReset<string | undefined>('')
export const addressPostalCodeAtom = atomWithReset<string | undefined>('')
export const addressStateAtom = atomWithReset<string | undefined>('')
export const addressCountryAtom = atomWithReset<string | undefined>('')
export const addressUrlAtom = atomWithReset<string | undefined>('')

export const resetAddressForm = () => {
	getStore().set(addressStreetAtom, RESET)
	getStore().set(addressPostalCodeAtom, RESET)
	getStore().set(addressCityAtom, RESET)
	getStore().set(addressStateAtom, RESET)
	getStore().set(addressCountryAtom, RESET)
	getStore().set(addressUrlAtom, RESET)
}
